import Vue from 'vue';

export default Vue.component('expert-opinion-document-dialog', {
    data() {
        return {
            token: localStorage.getItem('accessToken') || null,
            opened: false,
            expertOpinionId: null
        };
    },
    created() {
        Event.listen('expertOpinionDocumentDialogOpen', (expertOpinionId) => {
            this.expertOpinionId = expertOpinionId;
            if (!this.token) {
                this.$modal.show('expert-opinion-document-dialog')
                this.opened = true
            }
        })
    },
    methods: {
        close() {
            this.opened = false
            this.$modal.hide(`expert-opinion-document-dialog`)
        },
        afterOpen() {
            if (this.expertOpinionId) {
                const el = document.querySelector('.form-expert-opinion > input[type=hidden][name=id]')
                if (el) {
                    el.value = this.expertOpinionId
                }
            }
        }
    }
});
